import { Injectable } from "@angular/core";
import { DefaultService, Scroller } from "@psnb/psnb-api";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ScrollerHistoryService {
    constructor(private powerSupplyService: DefaultService) {
        this.getAllScrollerHistory();
    }

    getAllScrollerHistory() {
        return this.powerSupplyService.getScrollerHistory()
            .pipe(map(result => result));
    }

    createScroller(model: Scroller) {
        return this.powerSupplyService.createScroller(model)
            .pipe(map(result => result));
    }

    updateScroller(model: Scroller) {
        return this.powerSupplyService.updateScroller(model)
            .pipe(map(result => result));
    }

    deleteScroller(id: number) {
        return this.powerSupplyService.deleteScroller(id)
            .pipe(map(result => result));
    }
}
